module.exports = __webpack_public_path__ + "img/horizontal_7_7_6005.a1593066.png";